import { Trans, useTranslation } from 'react-i18next'
import Skeleton from 'react-loading-skeleton'
import { SummarySection } from './SummarySection'
import { PremiumBeneMessages, PremiumSummaryInfo } from '@cms-max/medicare-api-sdk'
import { MyInternalLink, MyLinkClickHandler } from 'components/MyLink'
import { SsaLink } from '../SsaLink'
import { useEvent } from 'hooks/useEvent'

type MyPaymentsProps = {
    isLoading?: boolean
    summaryData?: PremiumSummaryInfo
}
export function MyPayments ({ isLoading, summaryData }: MyPaymentsProps) {
  const { t } = useTranslation('premiumsDashboardPage')
  const { fireEvent } = useEvent('premiumsLanding')
  const beneMessages = summaryData?.beneMessages
  const shouldShowValue = beneMessages?.paymentReceived || beneMessages?.lastPayment
  const value = isLoading ? <Skeleton height={144} /> : (shouldShowValue ? <LastPayment paymentReceived={beneMessages?.paymentReceived} lastPayment={beneMessages?.lastPayment} /> : null)
  const handleSsaLinkClick: MyLinkClickHandler = (params) => fireEvent('premiums_landingpage_ssaccount_click', params)

  return (
    <SummarySection
        heading={isLoading ? <Skeleton width={159} /> : t('myPayments.heading')}
        value={value}
        valueColor={isLoading ? undefined : 'green'}
        isLoading={isLoading}
    >
        {isLoading && <Skeleton height={55} />}
        {isLoading && <Skeleton height={43} width={164} className='ds-u-margin-top--3' />}
        {!isLoading && (
          <>
            {summaryData?.isDirectBillingEligible && (
              <p>{t('myPayments.paymentProcessDelay')}</p>
            )}

            {!summaryData?.isDirectBillingEligible && (
             <Trans
                i18nKey='myPayments.notEligibleContent'
                t={t}
                components={{ link1: <SsaLink onClick={handleSsaLinkClick} /> }}
              />
            )}

            <p><MyInternalLink to="/premiums/history" onClick={(params) => fireEvent('premiums_landingpage_recentpayments_click', params)}>{t('myPayments.recentPaymentsLink')}</MyInternalLink></p>

            {summaryData?.isDirectBillingEligible && (
              <p className='ds-u-margin-top--3'>
              <MyInternalLink to="/premiums/make-a-payment" className='ds-c-button ds-c-button--solid' onClick={(params) => fireEvent('premiums_landingpage_paynow_click', params)}>
                  {t('myPayments.payNowLink')}
              </MyInternalLink>
            </p>
            )}
          </>
        )}
    </SummarySection>
  )
}

export default MyPayments

type LastPaymentProps = Pick<PremiumBeneMessages, 'lastPayment' | 'paymentReceived'>
function LastPayment ({ paymentReceived, lastPayment }: LastPaymentProps) {
  const { i18n } = useTranslation('premiumsDashboardPage')
  const lang = i18n.language as 'en' | 'es'
  const lastPaymentStr = lastPayment?.[lang]
  const paymentReceivedStr = paymentReceived?.[lang]

  const lastPaymentArr = lastPaymentStr?.split(':')
  const paymentReceivedArr = paymentReceivedStr?.split(':')

  return (
    <div>
      {lastPaymentArr && lastPaymentArr.length > 1
        ? (
        <>
          <div className='ds-text-body--md'>{lastPaymentArr[0]}:</div>
          <div className="ds-text-body--lg ds-u-font-weight--semibold">{lastPaymentArr[1]}</div>
        </>
          )
        : lastPaymentStr ? (<div className='ds-text-body--md'>{lastPaymentStr}</div>) : null}

      {paymentReceivedArr && paymentReceivedArr.length > 1
        ? (
              <>
                <div className='ds-text-body--md'>{paymentReceivedArr[0]}:</div>
                <div className="ds-text-body--lg ds-u-font-weight--semibold">{paymentReceivedArr[1]}</div>
              </>
          )
        : paymentReceivedStr ? (<div className='ds-text-body--md'>{paymentReceivedStr}</div>) : null}
    </div>
  )
}
